import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/outline'
import YellowCircleInterrogation from 'components/Icons/YellowCircleInterrogation'
import { InputLabel } from 'components/InputLabel'
import { Label } from 'components/InputLabel/styles'
import DefaultModal from 'components/Modals'
import { HTMLAttributes, useEffect, useState } from 'react'
import { FieldValues, UseFormRegister, UseFormSetValue } from 'react-hook-form'
import { NotifyEventType } from 'validator/notify_event_validator'
import { MultiplierModalInfos } from './MultiplierModalInfos'
import DefaultMobileModal from 'components/MobileModal/MobileModal'
import { NotificationType } from 'types/notification'

interface MultiplierProps {
    showMultiplier: boolean
    register: UseFormRegister<FieldValues>
    setValue: UseFormSetValue<NotifyEventType>
    value: string
    containerClassName?: HTMLAttributes<HTMLDivElement>['className'];
    notification?: NotificationType,
}

export const Multiplier = ({
    showMultiplier,
    register,
    setValue,
    value,
    containerClassName,
    notification
}: MultiplierProps) => {
    if (!showMultiplier) {
        return null
    }

    const [multiplierModalInfos, setMultiplierModalInfos] = useState(false)

    const handleBlur = () => {
        if (value === '' || value === undefined || parseInt(value) < 1) {
            setValue('u_notification_multiplier', '1')
        }
    }

    const handleIncrement = () => {
        setValue(
            'u_notification_multiplier',
            Math.min(Number(value) + 1, 9999).toString(), { shouldDirty: true }
        )
    }

    const handleDecrement = () => {
        setValue(
            'u_notification_multiplier',
            Math.max(Number(value) - 1, 1).toString(), { shouldDirty: true }
        )
    }

    useEffect(() => {
        if (!value){
            setValue('u_notification_multiplier', '1')
        }
    }, [])

    return (
        <>
            <DefaultModal
                dialogPanelClass="hidden md:block"
                isOpen={multiplierModalInfos}
                handleCloseModal={() => {
                    setMultiplierModalInfos(false)
                }}
                children={
                    <MultiplierModalInfos
                        close={() => setMultiplierModalInfos(false)}
                    />
                }
            />

            <DefaultMobileModal
                containerClassNames="bottom-0"
                isOpen={multiplierModalInfos}
                closeModal={() => {
                    setMultiplierModalInfos(false)
                }}
                children={
                    <MultiplierModalInfos
                        close={() => setMultiplierModalInfos(false)}
                    />
                }
            />

            <div className={`w-full relative ${containerClassName}`}>
                <div className=" flex items-center text-center" >
                    <Label className="mr-2">Multiplicador</Label>                 
                    <div className="flex items-center cursor-pointer" onClick={() => { setMultiplierModalInfos(true) }}>
                        <YellowCircleInterrogation />
                        <span className="ml-2 text-sm underline font-semibold text-blueTheme">
                            Saiba mais
                        </span>
                    </div>
                </div>

                <p className="text-xs text-darkGray/80 my-1">
                    Quantas vezes esse incidente ocorreu
                </p>

                <ChevronUpIcon
                    onClick={handleIncrement}
                    className={`h-[16px] w-[16px] text-blueTheme absolute top-[46px] right-[15.5px] z-10 bg-white active:brightness-95`}
                    aria-hidden="true"
                />

                <InputLabel
                    defaultValue={notification?.u_notification_multiplier?.value}
                    onBlur={handleBlur}
                    maxLength={4}
                    min="1"
                    max="9999"
                    type="string"
                    register={register}
                    name="u_notification_multiplier"
                />

                <ChevronDownIcon
                    onClick={handleDecrement}
                    className={`h-[16px] w-[16px] text-blueTheme absolute bottom-0.5 right-[15.5px] z-10 bg-white active:brightness-95`}
                    aria-hidden="true"
                />
            </div>
        </>
    )
}
